import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutSettlementList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceSettlement: DataSource;
    tableSettlements: Table;
}
